const STRUCT = {
  CUSTOMER_ID: 'customer_id',
  EVENT_ID: 'event_id',
  FINE: 'fine',
  ID: 'id',
  REPRESENTATIVE_ID: 'representative_id',
};

export default STRUCT;
